import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";
import qs from "qs";

// 매장대회리스트
const get_ownertournamentlist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tournamentlistcnt: 0,
    tournamentlist: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/tournament/tournamentlist",
    headers: { Authorization: "Bearer " + token },
    params: {
      startdate: param.startdate,
      enddate: param.enddate,
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
      tour_rank_type: param.tour_rank_type,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        // console.error(response.data.code, response.data.message)
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_ownertournamentlist", err);
    result(false, err);
  }
};

// 매장대회랭킹리스트
const get_ownertournamentranklist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tournamentranklistcnt: 0,
    tournamentranklist: [],
    tournamentname: "",
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/tournament/tournamentranking/" + param.tournamentno,
    headers: { Authorization: "Bearer " + token },
    params: {
      scoretype: param.scoretype,
      gender: param.gender,
      pageno: param.pageno,
      pagesize: param.pagesize,
      tour_rank_type: param.tour_rank_type,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_ownertournamentranklist", err);
    result(false, err);
  }
};

// 매장코스리스트
const get_ownertournamentview = async (tournamentno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tournamentshopname: 0,
    tournamentinfo: [],
    tournamentprizeetc: [],
    tournamentprizerankcnt: "",
    tournamentprizerank: [],
    tournamentdetail: [],
    tournamentcoursecnt: "",
    tournamentcourse: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/tournament/tournamentinfo/" + tournamentno,
    headers: { Authorization: "Bearer " + token },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_ownertournamentview", err);
    result(false, err);
  }
};

// 토너먼트 조건 불러오기
const get_tournamentcondition = async (tournamentno, result) => {
  let finalData = {
    code: "",
    message: "",
    tournamentcondition: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/tournament/tournamentcondition/" + tournamentno,
    headers: { Authorization: "Bearer " + token },
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
  };
  try {
    await axios(options).then((response) => {
      console.log(response);
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_tournamentcondition", err);
  }
};

// 매장코스리스트
const get_ownertournamentcourselist = async (tournamentno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    courselistcnt: 0,
    courselist: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/tournament/tournamentcourselist/" + tournamentno,
    headers: { Authorization: "Bearer " + token },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_ownertournamentcourselist", err);
    result(false, err);
  }
};

// 통합관리대회서브코스리스트
const get_ownertournamentsubcourselist = async (courseno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    subcourselistcnt: 0,
    subcourselist: [],
  };

  const options = {
    method: "GET",
    url: "/tournament/tournamentsubcourselist/" + courseno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_ownertournamentsubcourselist", err);
    result(false, err);
  }
};
// 매장대회 등록
const set_ownertournamentwrite = async (form, result) => {
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "POST",
    url: "/tournament/tournamentwrite",
    headers: { Authorization: "Bearer " + token },
    data: qs.stringify({
      title: form.title,
      startdate: form.startdate,
      enddate: form.enddate,
      remark: form.remark,
      etcprize: form.etcprize,
      rankprizelistcnt: form.rankprizelistcnt,
      rankno: form.rankprizelist.rankno,
      rankprize: form.rankprizelist.rankprize,
      wind: form.wind,
      mulligan: form.mulligan,
      teeboxman: form.teeboxman,
      teeboxwoman: form.teeboxwoman,
      // playhandicap5: form.playhandicap5,
      // playhandicap10: form.playhandicap10,
      // playhandicap15: form.playhandicap15,
      // playhandicap20: form.playhandicap20,
      // playhandicap25: form.playhandicap25,
      // playhandicap30: form.playhandicap30,
      // playhandicap35: form.playhandicap35,
      // playhandicap40: form.playhandicap40,
      // playhandicap45: form.playhandicap45,
      // playhandicap50: form.playhandicap50,
      courselistcnt: form.courselistcnt,
      courseno: form.courselist,
      subcourselistcnt: form.subcourselistcnt,
      subcourselist: form.subcourselist,
      subcoursetype: form.subcoursetype,
      status: form.status,
    }),
  };

  try {
    await axios(options).then((response) => {
      // result(true, response.data)
      if (response.data.code === 200) {
        result(true, response.data.message);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("set_ownertournamentwrite", err);
    result(false, err);
  }
};

// 매장대회 수정
const set_ownertournamentedit = async (form, tournamentno, result) => {
  const token = sessionStorage.getItem("token") || null;
  form.rankprizelist.rankprize.splice(form.rankno);

  const options = {
    method: "POST",
    url: "/tournament/tournamentwrite/" + tournamentno,
    headers: { Authorization: "Bearer " + token },
    data: qs.stringify({
      title: form.title,
      startdate: form.startdate,
      enddate: form.enddate,
      remark: form.remark,
      etcprize: form.etcprize,
      rankprize: form.rankprizelist.rankprize,
      wind: form.wind,
      mulligan: form.mulligan,
      teeboxman: form.teeboxman,
      teeboxwoman: form.teeboxwoman,
      // playhandicap5: form.playhandicap5,
      // playhandicap10: form.playhandicap10,
      // playhandicap15: form.playhandicap15,
      // playhandicap20: form.playhandicap20,
      // playhandicap25: form.playhandicap25,
      // playhandicap30: form.playhandicap30,
      // playhandicap35: form.playhandicap35,
      // playhandicap40: form.playhandicap40,
      // playhandicap45: form.playhandicap45,
      // playhandicap50: form.playhandicap50,
      courselistcnt: form.courselistcnt,
      courseno: form.courselist,
      subcourselistcnt: form.subcourselistcnt,
      subcourselist: form.subcourselist,
      subcoursetype: form.subcoursetype,
      status: form.status,
    }),
  };

  try {
    await axios(options).then((response) => {
      // result(true, response.data)
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_ownertournamentwrite", err);
    result(false, err);
  }
};

// 회원정보보기
const get_playerinfo = async (player, type, result) => {
  let finalData = {
    code: "",
    message: "",
    playerbasicinfo: [],
    playerpalyinfo: [],
  };

  const options = {
    method: "GET",
    url: "/Common/playerinfo",
    params: {
      player: player,
      type: type,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_playerinfo", err);
    result(false, err);
  }
};

// 토너먼트참가리스트
const get_admintournamentplaylist = async (tour_pk, player_pk, result) => {
  let finalData = {
    code: "",
    message: "",
    pageno: 1,
    pagesize: 10,
    tournamentname: "",
    tournamentplaylistcnt: 0,
    tournamentplaylist: [],
  };
  const token = sessionStorage.getItem("token") || null;
  console.log("player_pk", player_pk);
  const options = {
    method: "GET",
    url:
      process.env.VUE_APP_API_URL +
      "/tournament/tournamentplaylist/" +
      tour_pk +
      "/" +
      player_pk,
    headers: { Authorization: "Bearer " + token },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_membertournamentplaylist", err);
    result(false, err);
  }
};

const get_memberscorecard = async (player_pk, define1_pk, result) => {
  let finalData = {
    code: "",
    message: "",
    scorecardinfo: {},
    scorecardstats: {},
    scorecardscore: {},
    scorecardtotal: {},
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url:
      process.env.VUE_APP_API_URL +
      "/tournament/scorecard/" +
      player_pk +
      "/" +
      define1_pk,
    //url: 'http://localhost/test.php',
    headers: { Authorization: "Bearer " + token },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_memberscorecard", err);
    result(false, err);
  }
};

// 토너먼트 결제 리스트
const get_tournamentpaymentlist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tournamentpaymentlistcnt: 0,
    tournamentpaymentlist: [],
  };

  const options = {
    method: "GET",
    url: "/tournament/tournamentpaymentlist/" + param.tour_pk,
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_tournamentpaymentlist", err);
    result(false, err);
  }
};

// 토너먼트 결제 리스트
const get_playerpaymentlist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    listcnt: 0,
    list: [],
  };

  const options = {
    method: "GET",
    url:
      "/membership/playerpaymentlist/" +
      param.player_pk +
      "/" +
      param.tour_pk +
      "/" +
      param.owner_pk,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_playerpaymentlist", err);
    result(false, err);
  }
};

export default {
  get_ownertournamentlist,
  get_ownertournamentranklist,
  get_ownertournamentview,
  get_tournamentcondition,
  get_ownertournamentcourselist,
  get_ownertournamentsubcourselist,
  set_ownertournamentwrite,
  set_ownertournamentedit,
  get_playerinfo,
  get_admintournamentplaylist,
  get_memberscorecard,
  get_tournamentpaymentlist,
  get_playerpaymentlist,
};
